const customerRecoverMutation = /* GraphQL */ `
  mutation customerRecover($input: String!) {
  customerRecover(email: $input) {
    customerUserErrors {
      code
      field
      message
    }
  }
}
`
export default customerRecoverMutation
